import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { AppDataService, DeliveryOrderService, RiderService } from 'app/services';
import { Utils } from 'app/utils';
import { DriverDetailComponent } from 'app/components/home/drivers/driver-detail/driver-detail.component';
import { Clipboard } from '@angular/cdk/clipboard';
import {
    BookingDetails,
    BookingDetailsTransaction,
    BookingStatus,
    ChatMessageTypeEnum,
    OrderRiderActionEnum,
    PaymentCardTypeEnum,
    XpressDeliveryStatus, BetaFeature,
    RiderVehicleTypeEnum,
    CancelReasonTypeEnum, CancelReasonTypeModel,
    XpressUserRoleEnum,
    ServiceTypeEnum,
    CompleteReasonTypeModel,
    CompleteReasonTypeEnum, SpecialDiscountTypeEnum,
    PricingBreakdown,
    PricingBreakdownLine,
    PricingBreakdownLineType
} from 'app/models';
import { PointWithAddress } from '@shared/models';
import { OrderUtils } from 'app/utils/order-utils';
import { AssigningRoundEnum } from 'app/active-orders/booking-detail/AssigningRound';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { ConfirmationDialogService } from '@shared/services/confirmation-dialog.service';

enum MenuTab {
    BookingDetail = 1,
    CustomerProfile = 2,
    Timeline = 3,
    Messages = 4,
    Assigning = 5,
    Customer = 6,
    Driver = 7,
    Payment = 8,
    ItemDetails = 9,
    People = 10
}

enum OrderImageType {
    Package = 1,
    PickUp = 2,
    DropOff = 3
}

@Component({
    selector: 'booking-detail',
    templateUrl: './booking-detail.component.html',
    styleUrls: ['./booking-detail.component.scss',
        '../../../../styles/sidebar.scss',
        '../../../../styles/style-layout.scss']
})
export class BookingDetailComponent implements OnInit {
    public orderId: number = 0;
    public transactionId: number = 0;
    public selectedOrder: any = {};
    @Input()
    set _orderId(value: number) {
        if (value > 0) {
            this.orderId = value;
            this.getRiderOrderDetail();
        }
    }

    public riderId: number = 0;
    @Input()
    set _riderId(value: number) {
        if (value > 0) {
            this.riderId = value;
        }
    }

    @Input()
    set _selectedOrder(value: any) {
        if (value) {
            this.selectedOrder = value;
        }
    }

    @Input()
    public driverDetailComponent!: DriverDetailComponent;

    public isVisibleDisplayOrderDetail: boolean = false;
    @Input()
    set _isVisibleDisplayOrderDetail(value: boolean) {
        this.isVisibleDisplayOrderDetail = value;
    }

    @Input()
    public onHide: () => void = () => { };

    @Output() changedVisibleDisplayOrderDetailEmit = new EventEmitter<boolean>();
    changedVisibleDisplayOrderDetail(increased: any) {
        this.changedVisibleDisplayOrderDetailEmit.emit(increased);
    }

    constructor(private messageService: MessageService,
        private deliveryOrderService: DeliveryOrderService,
        public appDataService: AppDataService,
        private clipboard: Clipboard,
		private riderService: RiderService,
		private confirmationDialogService: ConfirmationDialogService) {
        }

    public betaFeature = BetaFeature;

    public orderMarkers: google.maps.Marker[] = [];
    public map!: google.maps.Map;
    private locationProvider: google.maps.journeySharing.FleetEngineTripLocationProvider | null = null;
    public markerClusterer?: MarkerClusterer;
    public riderMarkers: google.maps.Marker[] = [];
    public polylineRoutes: any[] = [];

    public icons: any = {};

    public firstRadiusToSortRidersInM: string = '';
    public secondRadiusToSortRidersInM: string = '';
    public thirdRadiusToSortRidersInM: string = '';

    public chatMessageType = ChatMessageTypeEnum;
    public paymentCardType = PaymentCardTypeEnum;
    public xpressUserRole = XpressUserRoleEnum;

    protected readonly BookingStatus = BookingStatus;

    public menuTab = MenuTab;
    public activeTab: MenuTab = MenuTab.BookingDetail;
    public menuItems: MenuItem[] = [];

    public loading: boolean = false;

    public bookingStatus = BookingStatus;

    public riderOrderDetail!: BookingDetails;
    public pricingBreakdown?: PricingBreakdown;
    public customerReceipt?: PricingBreakdown;
    public driverReceipt?: PricingBreakdown;
    public pricingBreakdownLoading = false;
    public pricingBreakdownFailed = false;
    private pricingBreakdownOrderId?: number;
    public bookingTransactionDetails!: BookingDetailsTransaction;
    public riderMessages: any;
    public riderTimeline: any;

    public isOrderDetailSpinner: boolean = false;

    /** Загрузка блока Bookings / Completed / Spend с отдельного API */
    public isCustomerStatisticsLoading: boolean = false;

    public isPhoneNumberVerified: boolean = true;

    public totalTimeText: any = '0';
    public totalAttempts: any = 1;

    public xpressDeliveryStatus = XpressDeliveryStatus;
    public orderRiderActionEnum = OrderRiderActionEnum;
    public pricingBreakdownLineType = PricingBreakdownLineType;

    public customerId!: number;
    public isVisibleCustomerInfo: boolean = false;
    public visibleDriverDetail: boolean = false;
    public showAssingRiderPopup: boolean = false;

	public cancelB2bReasonTypeList = CancelReasonTypeModel.CancelB2bReasonTypeList;
	public cancelReasonTypeList = CancelReasonTypeModel.CancelReasonTypeList;
	public completeReasonTypeList = CompleteReasonTypeModel.CompleteReasonTypeList;

    public currentRider: any = null;

    // Example data
    // name: 'Andrew Rackcheev',
    // distance: '2',
    // imageUrl: 'https://primefaces.org/cdn/primeng/images/demo/avatar/amyelsner.png',
    // status: 'Active'
    public assignDriverItems: any = [];
    public round1Riders: any = [];
    public round2Riders: any = [];
    public round3Riders: any = [];

    public round1Selected: boolean = true;
    public round2Selected: boolean = false;
    public round3Selected: boolean = false;

    public currentRiderIndex: any = undefined;
    public currentRound: number = AssigningRoundEnum.First;

    public progressValue: number = 20;
    public targetValue: number = 0;
    public duration: number = 20000;

    public senderSelected: boolean = true;
    public recipientSelected: boolean = false;
    public driverSelected: boolean = false;

    //start galleria
    public infoItems: any = [];
    public activeImgIndex: number = 0;
    public displayImg: boolean = false;
    public imageOptions: any[] = [
        {
            breakpoint: '1500px',
            numVisible: 5
        },
        {
            breakpoint: '1024px',
            numVisible: 3
        },
        {
            breakpoint: '768px',
            numVisible: 2
        },
        {
            breakpoint: '560px',
            numVisible: 1
        }
    ];

    scheduledBookingConfig = {
        statuses: [XpressDeliveryStatus.New, XpressDeliveryStatus.RiderAccept],
        canBeCancelled: false
    };

    public showVisibleImageModal(orderImageType: number) {
        switch (orderImageType) {
            case OrderImageType.Package:
                this.infoItems = [
                    { value: this.riderOrderDetail.PackagePhotoImageUrl, ind: 0, title: 'Photo uploaded by Customer',
                        subTitle: this.riderOrderDetail.DeliveryWeight + 'kg • ' + this.riderOrderDetail.DeliveryItemTypeText }
                ];
                break;
            case OrderImageType.PickUp:
                this.infoItems = [
                    { value: this.riderOrderDetail.PickupPhotoImageUrl, thumbnail: true, ind: 0,
                        title: 'Pick Up Photo', subTitle: 'Date and Time: ' + this.riderOrderDetail.PickedUpFormattedTime },
                    { value: this.riderOrderDetail.PickupSignatureImageUrl, thumbnail: true, ind: 1,
                        title: 'Sender\'s Signature', subTitle: 'Date and Time: ' + this.riderOrderDetail.PickedUpFormattedTime }
                ];
                break;
            case OrderImageType.DropOff:
                this.infoItems = [
                    { value: this.riderOrderDetail.DropPhotoImageUrl, thumbnail: true, ind: 0,
                        title: 'Drop Off Photo', subTitle: 'Date and Time: ' + this.riderOrderDetail.DropOffFormattedTime },
                    { value: this.riderOrderDetail.DropSignatureImageUrl, thumbnail: true, ind: 1,
                        title: 'Recipient\'s Signature', subTitle: 'Date and Time: ' + this.riderOrderDetail.DropOffFormattedTime }
                ];
                break;
        }
        this.activeImgIndex = 0;
        this.displayImg = true;
    }
    //end galleria

    async setCurrentRider(isCurrentExpired: boolean = false) {
        await this.getRiderAssigning();
        if (isCurrentExpired && this.currentRider) {
            this.currentRider.RiderAction = OrderRiderActionEnum.TimedOut;
        }
        if (this.riderOrderDetail.StatusId !== XpressDeliveryStatus.RiderAssigning) {
            return;
        }

        this.setCurrentAssigningData();
        if (!this.currentRider) {
            return;
        }

        this.progressValue = 20;
        this.animateProgress();
    }

    animateProgress() {
        const interval = 50;
        const steps = this.duration / interval;
        const stepValue = (this.targetValue - this.progressValue) / steps;

        const progressInterval = setInterval(async () => {
            this.progressValue += stepValue;
            if (this.progressValue <= this.targetValue) {
                clearInterval(progressInterval);
                if ((this.currentRiderIndex === this.round3Riders.length-1) && this.currentRound === AssigningRoundEnum.Third) {
                    this.riderOrderDetail.StatusId = XpressDeliveryStatus.Expired;
                    this.currentRound = AssigningRoundEnum.None;
                }
                await this.setCurrentRider(true);
            }
        }, interval);
    }


    copyTextToClipboard(data: any) {
        this.clipboard.copy(data.toString());
    }

    private async loadPricingBreakdown(orderId: number): Promise<void> {
        this.pricingBreakdown = undefined;
        this.customerReceipt = undefined;
        this.driverReceipt = undefined;
        this.pricingBreakdownFailed = false;
        this.pricingBreakdownLoading = true;
        this.pricingBreakdownOrderId = orderId;

        if (!orderId) {
            this.pricingBreakdownLoading = false;
            return;
        }

        try {
            const response = await this.deliveryOrderService.getOrderPricingBreakdown({ XpressDeliveryOrderId: orderId });

            // Drop stale responses: another order may have been opened while this request was in flight.
            if (this.pricingBreakdownOrderId !== orderId) {
                return;
            }

            if (response?.Success) {
                this.pricingBreakdown = response.Breakdown;
                this.customerReceipt = response.Customer;
                this.driverReceipt = response.Driver;
            } else {
                this.pricingBreakdownFailed = true;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: response?.ErrorMessage || 'Failed to load pricing breakdown'
                });
            }
        } catch (error: any) {
            if (this.pricingBreakdownOrderId !== orderId) {
                return;
            }

            this.pricingBreakdownFailed = true;
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error?.ErrorMessage || error?.message || 'Failed to load pricing breakdown'
            });
        } finally {
            // Only the most recent request controls the loading flag.
            if (this.pricingBreakdownOrderId === orderId) {
                this.pricingBreakdownLoading = false;
            }
        }
    }

    public retryPricingBreakdown(): void {
        const orderId = this.riderOrderDetail?.XpressDeliveryOrderId;
        if (orderId) {
            this.loadPricingBreakdown(orderId);
        }
    }

    public formatBreakdownAmount(line: PricingBreakdownLine): string {
        if (line.LineType === PricingBreakdownLineType.Text) {
            return line.Text || '-';
        }

        const amount = line.Amount ?? 0;
        const isNegative = line.LineType === PricingBreakdownLineType.Deduction || amount < 0;
        return `${isNegative ? '- ' : ''}₱ ${Math.abs(amount).toFixed(2)}`;
    }

    public isBreakdownDeduction(line: PricingBreakdownLine): boolean {
        return line.LineType === PricingBreakdownLineType.Deduction;
    }

    public isBreakdownTotal(line: PricingBreakdownLine): boolean {
        return line.LineType === PricingBreakdownLineType.Total;
    }

    ngOnInit() {
        this.addVehicleTypeIcons();
    }

    public async getRiderOrderDetail() {
		this.loading = true;
        try {
            this.isOrderDetailSpinner = true;

            const dto = {
                XpressDeliveryOrderId: this.orderId,
                TimeZoneOffset: Utils.getTimezoneOffset()
            };

            const data = await this.deliveryOrderService.getDeliveryOrderDetail(dto, this.messageService);

            if (!data.Success) {
                this.handleOrderDetailError(data.ErrorMessage);
                this.loading = false;
                return;
            }

            this.handleOrderDetailSuccess(data);
            this.scheduledBookingConfig.canBeCancelled = this.isCancellableScheduledBooking();
        } catch (err) {
            this.handleError(err);
            this.loading = false;
        } finally {
            this.isOrderDetailSpinner = false;
            this.loading = false;
        }
    }

    public displayRouteInMap(points: PointWithAddress[], riderImageUrl: string, riderName: string, sessionTime: string): Promise<void> {
        //not show route if tab is not selected
        if (!document.getElementById('map')) {
            return new Promise<void>((resolve, reject) => {
                resolve();
            });
        }
        if (!this.map) {
            this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
                zoom: 15,
                center: { lat: points[0].Lat, lng: points[0].Long },
            });
        }

        const startPoint = { lat: points[0].Lat, lng: points[0].Long };
        const endPoint = { lat: points[points.length - 1].Lat, lng: points[points.length - 1].Long };

        const directionsService = new google.maps.DirectionsService();

        const waypoints = points.slice(1, -1).map((point: any) => ({
            location: new google.maps.LatLng(point.Lat, point.Long),
            stopover: false,
        }));

        const request: google.maps.DirectionsRequest = {
            origin: new google.maps.LatLng(points[0].Lat, points[0].Long),
            destination: new google.maps.LatLng(points[points.length - 1].Lat, points[points.length - 1].Long),
            waypoints,
            travelMode: google.maps.TravelMode.DRIVING,
        };

        return new Promise((resolve, reject) => {
            directionsService.route(request, (result, status) => {
                if (status === google.maps.DirectionsStatus.OK && result) {
                    const routePath = new google.maps.Polyline({
                        path: result.routes[0].overview_path,
                        geodesic: true,
                        strokeColor: '#1CBA70',
                        strokeOpacity: 1.0,
                        strokeWeight: 5,
                        map: this.map,
                    });

                    new google.maps.Marker({
                        position: startPoint,
                        map: this.map,
                        icon: {
                            url: '/Content/xpress-app/images/svg/green-ellipse-marker.svg',
                            scaledSize: new google.maps.Size(13, 13),
                        },
                        title: `Start Point`,
                    });

                    const endMarker = new google.maps.Marker({
                        position: endPoint,
                        map: this.map,
                        icon: {
                            url: '/Content/xpress-app/images/svg/green-ellipse-marker.svg',
                            scaledSize: new google.maps.Size(13, 13),
                        },
                        title: `End Point`,
                    });

                    resolve();
                } else {
                    reject(`Directions request failed`);
                }
            });
        });
    }

    public getLastRiderLocation(riderId: number) {
        const dto = {
            RiderId: riderId
        };

        this.riderService.getLastRiderLocation(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                // Add rider markers
                this.addRiderMarkers(data);
            });
    }

    public addRiderMarkers(rider: any) {
        if (!this.map) {
            return;
        }
        try {
            this.markerClusterer?.removeMarkers(this.riderMarkers);
            for (const riderMarker of this.riderMarkers) {
                riderMarker.setMap(null);
            }
            this.riderMarkers = [];

            const vehicleIcon: string = this.getVehicleIcon(rider.VehicleTypeId);

            const marker = new google.maps.Marker({
                position: { lat: rider.LastLocation.Lat, lng: rider.LastLocation.Long },
                icon: vehicleIcon,
            });

            marker.set('riderId', rider.RiderId);

            const infoWindow = new google.maps.InfoWindow({
                content: `
                        <div style="position: relative; overflow: hidden;">
                        ${(this.riderOrderDetail.StatusId === XpressDeliveryStatus.ArrivedToPickup) ?
                        `<div id="progress-bar" style="height: 5px; background: red; width: 100%; transition: width 1s linear;"></div>` : ``}
                        <div style="display: flex; align-items: center; gap: 10px; padding: 10px; background: white;">
                          <img src="${rider.ImageUrl}" alt="Profile Picture" style="width: 50px; height: 50px; border-radius: 50%; object-fit: cover;">
                          <div>
                            <div style="font-size: 14px; font-weight: bold; color: #000;">${rider.UserName}</div>
                            <div id="elapsed-timer" style="margin-top: 5px; padding: 5px 10px; background:
                            ${(this.riderOrderDetail.StatusId === XpressDeliveryStatus.ArrivedToPickup) ? `#dc3545` : `#28a745` }; color: white; font-size: 12px; 
                            font-weight: bold; border-radius: 5px; text-align: center;">
                              ${(this.riderOrderDetail.StatusId === XpressDeliveryStatus.ArrivedToPickup) ? `Waiting Time: 00:05:00` :
                        `Elapse Time: ${this.riderOrderDetail.SessionTime}`}
                            </div>
                          </div>
                        </div>
                      </div>
                        `,
            });

            const arrivedToPickupAt = (this.riderOrderDetail.ArrivedToPickupAt) ? Utils.utcToLocalDate(this.riderOrderDetail.ArrivedToPickupAt) : new Date();

            const updateElapsedTimer = () => {
                if (arrivedToPickupAt) {
                    const now = new Date();
                    const elapsedMilliseconds = now.getTime() - arrivedToPickupAt.getTime();
                    const elapsedSeconds = Math.floor(elapsedMilliseconds / 1000);

                    const minutes = Math.floor(elapsedSeconds / 60);
                    const seconds = elapsedSeconds % 60;

                    const timerElement = document.getElementById('elapsed-timer');
                    if (timerElement) {
                        timerElement.innerText = `Elapse Time: ${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
                    }

                    const progressBar = document.getElementById('progress-bar');
                    if (progressBar) {
                        const progress = Math.min((elapsedSeconds / 300) * 100, 100);
                        progressBar.style.width = `${progress}%`;
                    }

                    if (elapsedSeconds < 300) {
                        setTimeout(updateElapsedTimer, 1000);
                    }
                } else {
                    console.error('arrivedToPickupAt is null or undefined');
                }
            };

            marker.addListener('click', () => {
                infoWindow.open(this.map, marker);
                if (this.riderOrderDetail.StatusId === XpressDeliveryStatus.ArrivedToPickup){ updateElapsedTimer(); }
            });

            this.riderMarkers.push(marker);

            this.markerClusterer = new MarkerClusterer({ map: this.map, markers: this.riderMarkers });

            this.map.setCenter({ lat: rider.LastLocation.Lat, lng: rider.LastLocation.Long });
        }
        catch (err) {
            this.handleError(err);
        }
    }

    private isCancellableScheduledBooking(): boolean {
        return this.scheduledBookingConfig.statuses.includes(this.riderOrderDetail.StatusId) && !!this.riderOrderDetail.ScheduledAt;
	}

	public cancelDeliveryOrder() {
		const order = this.riderOrderDetail;

		const isB2bSecondary = order.BookingLabel === 'B2B';
		const canBeCancelled = this.scheduledBookingConfig.canBeCancelled;

		const dialogData = Utils.buildCancelDialogData(
			order.ServiceTypeId,
			isB2bSecondary
		);

		const reasonList = isB2bSecondary ? this.cancelB2bReasonTypeList : this.cancelReasonTypeList;

		this.confirmationDialogService
			.confirmCancelTrip(
				dialogData.title,
				dialogData.message,
				dialogData.backLabel,
				dialogData.confirmLabel,
				reasonList
			)
			.subscribe((response: any) => {
				if (response.success) {
					const reasonObj = reasonList.find(item => item.value === response.reasonType);
					const cancelReason = (reasonObj && response.reasonType !== CancelReasonTypeEnum.Other)
						? reasonObj.name
						: (response.reasonText ?? 'Order canceled by Administrator');

					const dto = {
						Id: this.riderOrderDetail.XpressDeliveryOrderId,
						CancelReasonType: response.reasonType,
						CancelReason: cancelReason
					};

					this.performCancel(dto, isB2bSecondary, canBeCancelled);
				}
			});
	}

	private performCancel(dto: any, isB2bSecondary: boolean, canBeCancelled: boolean) {
		this.loading = true;

		this.deliveryOrderService.cancelDeliveryOrder(dto, this.messageService)
			.then(data => {
				if (!data) {
					this.loading = false;
					return;
				}

				if (!data.Success) {
					this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
					this.loading = false;
					return;
				}

				if (isB2bSecondary) {
					this.messageService.add({
						severity: 'success', summary: 'Booking Cancelled',
						detail: 'The back-to-back ride has been cancelled. The driver and customer have been notified.'
					});
				}
				else if (canBeCancelled) {
					this.messageService.add({
						severity: 'success',
						summary: 'Booking Cancelled',
						detail:
							'The trip has been cancelled. The driver and customer have been notified.',
					});
					this.riderOrderDetail.StatusText = 'Admin Cancelled';
					this.riderOrderDetail.StatusId = XpressDeliveryStatus.Canceled;
				}
				else {
					this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully canceled' });
				}

				this.onHide();
				this.loading = false;
			});
	}

    public completeOrder() {
        this.confirmationDialogService
            .confirmCompleteTrip('','','','',
                this.completeReasonTypeList
            )
            .subscribe((response: any) => {
                if (response.success) {
					this.loading = true;
                    const reasonObj = this.completeReasonTypeList.find(item => item.value === response.reasonType);
                    const completeReason = (reasonObj && response.reasonType !== CompleteReasonTypeEnum.Other)
                        ? reasonObj.name
						: (response.reasonText ?? 'Order completed by Administrator');

                    const dto = {
                        OrderId: this.riderOrderDetail.XpressDeliveryOrderId,
                        CompleteReason: completeReason
                    };

                    this.deliveryOrderService.completeOrder(dto, this.messageService)
                        .then(data => {
                            if (!data) {
                                this.loading = false;
                                return;
                            }

                            if (!data.Success) {
                                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                                this.loading = false;
                                return;
                            }

                            this.messageService.add({
                                severity: 'success',
                                summary: 'Booking Completed',
                                detail: 'The Trip  has been completed. The driver and customer have been notified.'
                            });
                            this.onHide();
                            this.loading = false;
                        });
                } else {
                    this.loading = false;
                }
            });
    }

    public onRiderAssign() {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Offer sent to rider' });

        this.showAssingRiderPopup = false;
    }

    public onAssingRiderClick() {
        this.showAssingRiderPopup = true;
    }

    public onAssingRiderPopupHide(): void {
        this.showAssingRiderPopup = false;
    }

    public isForceAssignVisible(): boolean {
        if (!this.riderOrderDetail) {
            return false;
        }

        return OrderUtils.isForceAssignVisible(
            this.riderOrderDetail.ServiceTypeId,
            this.riderOrderDetail.isScanAndRide === true,
            this.appDataService.getClientLocationType()
        );
    }

    getPriority() {
        return this.riderOrderDetail.IsPriority ? 'VIP' : 'Regular';
    }

    public onPrioritizeClick(): void {
        const dto: any = {
            OrderId: this.riderOrderDetail.XpressDeliveryOrderId
        };

        this.deliveryOrderService.prioritizeOrder(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully updated' });

                this.riderOrderDetail.IsPriority = true;
            });
    }

    public async getRiderAssigning() {
        try {
            const dto = {
                OrderId: this.orderId,
                TimeZoneOffset: Utils.getTimezoneOffset()
            };

            const data = await this.deliveryOrderService.getRiderAssigningHistory(dto, this.messageService);
            if (!data.Success) {
                this.handleOrderDetailError(data.ErrorMessage);
                return;
            }

            this.firstRadiusToSortRidersInM = data.FirstRadiusToSortRidersInM;
            this.secondRadiusToSortRidersInM = data.SecondRadiusToSortRidersInM;
            this.thirdRadiusToSortRidersInM = data.ThirdRadiusToSortRidersInM;

            this.assignDriverItems = data.RiderAssigningList;
            this.round1Riders = this.assignDriverItems.filter((x: any) => x.RoundNumber === AssigningRoundEnum.First);
            this.round2Riders = this.assignDriverItems.filter((x: any) => x.RoundNumber === AssigningRoundEnum.Second);
            this.round3Riders = this.assignDriverItems.filter((x: any) => x.RoundNumber === AssigningRoundEnum.Third);

            this.totalAttempts = data.AttemptsCount;
            this.totalTimeText = data.TotalTimeText;
        } catch (err) {
            this.handleError(err);
        } finally {
        }
    }

    private handleOrderDetailError(errorMessage: string) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: errorMessage });
    }

    private handleOrderDetailSuccess(data: any) {
        try {
            this.loading = false;

            this.riderOrderDetail = new BookingDetails(data);
            this.updateOrderStatusIfExpired();
            this.loadPricingBreakdown(this.riderOrderDetail.XpressDeliveryOrderId);

            this.bookingTransactionDetails = new BookingDetailsTransaction(data.XpressPaymentTransaction);
            this.getMenuTabItems(this.riderOrderDetail.LocalStatusText);

            window.setTimeout(() => {
                this.displayRouteInMap(data.Points, data.RiderImageUrl, data.RiderName, data.SessionTime);
                if (data.StatusId !== XpressDeliveryStatus.Completed && data.StatusId !== XpressDeliveryStatus.Canceled &&
                    this.riderOrderDetail.RiderId > 0) {
                    this.getLastRiderLocation(this.riderOrderDetail.RiderId);
                }
            }, 2000);
        } catch (error) {
            this.handleOrderDetailError('Error parsing order detail.');
            this.loading = false;
        }
    }

    private updateOrderStatusIfExpired() {
        if (this.riderOrderDetail.StatusText === BookingStatus.Arrived || this.riderOrderDetail.StatusText === BookingStatus.PickingUp) {
            this.riderOrderDetail.StatusText = BookingStatus.WaitingForPassenger;

            let progressVal = this.getRemainingWaitingTime(this.riderOrderDetail);
            const progressInterval = setInterval(() => {
                progressVal -= 1;
                if (progressVal < 1) {
                    this.updateOrderStatusIfExpired();
                    clearInterval(progressInterval);
                }
            }, 1000);
        } else if (this.riderOrderDetail.StatusText === BookingStatus.WaitingForPassenger) {
            if (this.riderOrderDetail.IsCustomerAcceptWaitingTime) {
                this.riderOrderDetail.StatusText = BookingStatus.WaitingExtended;

                let progressVal = this.getRemainingWaitingTime(this.riderOrderDetail, true);
                const progressInterval = setInterval(() => {
                    progressVal -= 1;
                    if (progressVal < 1) {
                        clearInterval(progressInterval);
                    }
                }, 1000);
            }
        }
    }

    getRemainingWaitingTime(rider: any, isRemaining: boolean = false) {
        const timeToSubstract = isRemaining
            ? (new Date(rider.ArrivedToPickupAt).getTime() + (rider.WaitingTimeInSec * 1000))
            : new Date(rider.ArrivedToPickupAt).getTime();
        // Рассчитываем разницу между текущим временем и временем прибытия
        const elapsedSeconds = (new Date().getTime() - timeToSubstract) / 1000;
        // Вычисляем оставшееся время ожидания
        const remainingSeconds = isRemaining ? rider.RemainingTimeSeconds - elapsedSeconds : rider.WaitingTimeInSec - elapsedSeconds;
        return Math.max(remainingSeconds, 0);
    }

    private handleError(err: any) {
        console.log(err);
        this.loading = false;
        throw err;
    }

    getMenuTabItems(statusId: any){
        if (statusId === BookingStatus.Requesting) {
            this.menuItems = [
                {
                    label: 'Details',
                    command: () => this.menuTabChange(MenuTab.BookingDetail)
                },
                {
                    label: 'Customer Profile',
                    command: () => this.menuTabChange(MenuTab.CustomerProfile)
                }
            ];
        } else {
            this.menuItems = [
                {
                    label: 'Details',
                    command: () => this.menuTabChange(MenuTab.BookingDetail)
                },
                {
                    label: 'People',
                    command: () => this.menuTabChange(MenuTab.People)
                },
                {
                    label: 'Item Details',
                    command: () => this.menuTabChange(MenuTab.ItemDetails)
                },
                {
                    label: 'Payment',
                    command: () => this.menuTabChange(MenuTab.Payment)
                },
                {
                    label: 'Messages',
                    command: () => this.menuTabChange(MenuTab.Messages)
                },
                {
                    label: 'Timeline',
                    command: () => this.menuTabChange(MenuTab.Timeline)
                }
            ];
        }

        if (!this.riderOrderDetail.isScanAndRide) {
            this.menuItems.push({
                label: 'Assigning',
                command: (e: any) => this.menuTabChange(MenuTab.Assigning)
            });
        }
    }

    public async menuTabChange(menuTab: MenuTab) {
        this.activeTab = menuTab;

        if (this.activeTab === MenuTab.BookingDetail) {
            await this.getRiderOrderDetail();
        }
        else if (this.activeTab === MenuTab.Assigning && this.riderOrderDetail.StatusId) {
            await this.setCurrentRider();
        }
        else if (this.activeTab === MenuTab.People || this.activeTab === MenuTab.CustomerProfile) {
            await this.loadCustomerStatistics();
        }
    }

    public async loadCustomerStatistics(): Promise<void> {
        if (!this.riderOrderDetail?.UserId) {
            return;
        }

        this.isCustomerStatisticsLoading = true;
        try {
            const dto = {
                UserId: this.riderOrderDetail.UserId
            };

            const data = await this.deliveryOrderService.getCustomerStatistics(dto, this.messageService);
            if (!data) {
                return;
            }

            if (!data.Success) {
                this.handleOrderDetailError(data.ErrorMessage ?? 'Failed to load customer statistics');
                return;
            }

            this.riderOrderDetail.BookingsCount = data.BookingsCount;
            this.riderOrderDetail.CompletedCount = data.CompletedCount;
            this.riderOrderDetail.CompletedPercent = data.CompletedPercent;
            this.riderOrderDetail.TotalSpend = data.TotalSpend;
        } catch (err) {
            this.handleError(err);
        } finally {
            this.isCustomerStatisticsLoading = false;
        }
    }

    getPhoneVerificationStatus(): string {
        return this.isPhoneNumberVerified
            ? 'Verified' : 'Not Verified';
    }

    public isVisibleForceAssignDialog: boolean = false;

    showForceAssignDialog(){
        this.isVisibleForceAssignDialog = true;
    }

    hideForceAssignDialog() {
        this.isVisibleForceAssignDialog = false;
    }

    changedVisibleDriverDetailEmit(value: any) {
        this.visibleDriverDetail = value;
    }

    public handleCustomerInfoClick(customerId: number): void {
        this.customerId = customerId;
        this.isVisibleCustomerInfo = true;
    }
    changedVisibleCustomerInfoEmit(value: any) {
        this.isVisibleCustomerInfo = value;
    }

    cancel() {
        this.changedVisibleDisplayOrderDetail(false);
    }

    private setCurrentAssigningData() {
        if (!this.checkRound(this.round1Riders)) {
            if (!this.checkRound(this.round2Riders)) {
                if (!this.checkRound(this.round3Riders)) {
                    this.currentRound = AssigningRoundEnum.None;
                }
            }
        }
    }

    private checkRound(riders: any) {
        const riderIndex = riders.findIndex((item: any) => item.RiderAction === OrderRiderActionEnum.Offer);
        const rider = riders.find((item: any) => item.RiderAction === OrderRiderActionEnum.Offer);

        if (riderIndex !== -1 && rider) {
            this.currentRiderIndex = riderIndex;
            this.currentRider = rider;
            this.currentRound = rider.RoundNumber;
            this.setRoundTab(this.currentRound);
            return true;
        }

        return false;
    }

    private setRoundTab(round: AssigningRoundEnum) {
        switch (round) {
            case AssigningRoundEnum.First:
                this.round1Selected = true;
                this.round2Selected = false;
                this.round3Selected = false;
                break;
            case AssigningRoundEnum.Second:
                this.round1Selected = false;
                this.round2Selected = true;
                this.round3Selected = false;
                break;
            case AssigningRoundEnum.Third:
                this.round1Selected = false;
                this.round2Selected = false;
                this.round3Selected = true;
                break;
            case AssigningRoundEnum.None:
                this.round1Selected = false;
                this.round2Selected = false;
                this.round3Selected = false;
                break;
        }
    }

    protected readonly OrderUtils = OrderUtils;
    protected readonly AssigningRoundEnum = AssigningRoundEnum;
    protected readonly OrderRiderActionEnum = OrderRiderActionEnum;
    protected readonly OrderImageType = OrderImageType;

    private addVehicleTypeIcons() {
        this.icons = {
            car: {
                active: this.getImage('car', true)
            },
            moto: {
                active: this.getImage('moto', true)
            },
            suv: {
                active: this.getImage('suv', true)
            },
            filter_car: {
                active: this.getImage('filter_car', true)
            },
            filter_suv: {
                active: this.getImage('filter_suv', true)
            },
            filter_moto: {
                active: this.getImage('filter_moto', true)
            },
            heatmap: {
                active: this.getImage('heatmap', true)
            },
            campaign: {
                active: this.getImage('campaign', true)
            },
            xpress50Rider4w: {
                active: this.getImage('xpress100', true)
            },
            etrike: {
                active: this.getImage('etrike', true)
            },
            filter_etrike: {
                active: this.getImage('filter_etrike', true)
            },
            van: {
                active: this.getImage('van', true),
            },
            filter_van: {
                active: this.getImage('filter_van', true)
            },
            trike: {
                active: this.getImage('trike', true)
            },
            filter_trike: {
                active: this.getImage('filter_trike', true)
            },
            minibus: {
                active: this.getImage('minibus', true)
            },
            filter_minibus: {
                active: this.getImage('filter_minibus', true)
            },
            multicab: {
                active: this.getImage('multicab', true)
            },
            filter_multicab: {
                active: this.getImage('filter_multicab', true)
            }
        };
    }

    public getImage(icon: string, isActive: boolean) {
        let result = '/XpressApp/assets/images/live-map-icons/' + icon + '_';
        result += isActive ? 'active' : 'inactive';
        result += '.png';
        return result;
    }

    getVehicleIcon(vehicleType: RiderVehicleTypeEnum): string {
        let vehicleIcon: string = '';

        switch (vehicleType) {
            case RiderVehicleTypeEnum.Moto: {
                vehicleIcon = this.icons.moto.active;
                break;
            }
            case RiderVehicleTypeEnum.Sedan: {
                vehicleIcon = this.icons.car.active;
                break;
            }
            case RiderVehicleTypeEnum.SUV: {
                vehicleIcon = this.icons.suv.active;
                break;
            }
            case RiderVehicleTypeEnum.ETrike: {
                vehicleIcon = this.icons.etrike.active;
                break;
            }
            case RiderVehicleTypeEnum.Van: {
                vehicleIcon = this.icons.van.active;
                break;
            }
            case RiderVehicleTypeEnum.Minibus: {
                vehicleIcon = this.icons.minibus.active;
                break;
            }
            case RiderVehicleTypeEnum.Multicab: {
                vehicleIcon = this.icons.multicab.active;
                break;
            }
            default: { break; }
        }

        return vehicleIcon;
    }

    protected readonly ServiceTypeEnum = ServiceTypeEnum;
    protected readonly SpecialDiscountTypeEnum = SpecialDiscountTypeEnum;
    protected readonly RiderVehicleTypeEnum = RiderVehicleTypeEnum;
}
